import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';

interface OrderDetailsHeaderProps {
    customerEmail: string;
    customerSupportPageUrl: string;
}

export const OrderDetailsHeader = (props: OrderDetailsHeaderProps) => {
    const { customerEmail, customerSupportPageUrl } = props;

    return (
        <>
            <div className="OrderDetails__Header">
                <h1 className="OrderDetails__Heading">{getTranslation(keys['orderSummary.thankYouHeader'])}.</h1>
                <p className="OrderDetails__OrderConfirmation">
                    {customerEmail ? (
                        <>
                            {getTranslation(keys['orderSummary.emailConfirmation'])} <strong>{customerEmail}.</strong>
                            <br />
                        </>
                    ) : (
                        <>
                            {getTranslation(keys['orderSummary.emailConfirmationFallback'])}
                            <br />
                        </>
                    )}
                    {getTranslation(keys['orderSummary.contactCustomerService'])}{' '}
                    <a href={customerSupportPageUrl}>{getTranslation(keys['orderSummary.customerService'])}.</a>
                </p>
            </div>
        </>
    );
};
